import DateFnsUtils from "@date-io/date-fns";
import {
  Card,
  FormControl,
  FormGroup,
  Grid,
  Icon,
  Paper,
  Toolbar,
} from "@material-ui/core";
import CardContent from "@material-ui/core/CardContent";
import CircularProgress from "@material-ui/core/CircularProgress";
import Fab from "@material-ui/core/Fab";
import { withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Tooltip from "@material-ui/core/Tooltip";
import Search from "@material-ui/icons/Search";
import {
  ExcelExport,
  ExcelExportColumn,
} from "@progress/kendo-react-excel-export";
import { Select as SelectAntd } from "antd";
import { InlineDatePicker, MuiPickersUtilsProvider } from "material-ui-pickers";
import PropTypes from "prop-types";
import React, { Component } from "react";
import Chart from "react-google-charts";
import { ValidatorForm } from "react-material-ui-form-validator";
import { connect } from "react-redux";

import Dialog from "../../components/Dialog";
import datetimeHelper from "../../helper/datetime-helper";
import { globalHistory } from "../../history";
import { mapActionsToProps as agentAction } from "./../../redux/agent";
import { mapActionsToProps as phoneNumberAction } from "./../../redux/cloudPBX/phoneNumber";
import { mapActionsToProps } from "./../../redux/dashboard";

const styles = (theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
    overflowX: "auto",
  },
  table: {
    minWidth: 700,
  },
  input: {
    width: "100%",
  },
  form: {
    width: "100%",
  },
});

class ReportOutbound extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filters: {
        order: "createdAt DESC",
        where: {
          from: datetimeHelper.toFormat(new Date(), "YYYY-MM-DD"),
          to: datetimeHelper.toFormat(new Date(), "YYYY-MM-DD"),
        },
        page: 0,
        pageSize: 20,
      },
      timeTo: null,
      timeFrom: null,
    };
  }
  async componentDidMount() {
    // await this.itemInit();
    this.history = globalHistory();
    this.props.getListGroupAgent();
    this.props.getListPhoneNumber();
    this.props.dashboardOutbound(
      datetimeHelper.toFormat(
        this.state.filters.where.from,
        "YYYY-MM-DD startDay"
      ),
      datetimeHelper.toFormat(this.state.filters.where.to, "YYYY-MM-DD endDay"),
      this.state.number,
      this.state.groupId
    );
  }

  handleChangePage = (e, page) => {
    const { filters } = this.state;
    this.setState({ page });
    filters.page = page * filters.pageSize;
    this.itemInit();
  };

  handleChangeRowsPerPage = (e) => {
    const { filters } = this.state;
    filters.pageSize = e.target.value;
    this.setState(
      {
        filters,
      },
      () => {
        this.itemInit();
      }
    );
  };

  handleSearch = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    const { filters } = this.state;
    filters.where[name] = value;
    this.setState({
      filters,
    });
  };
  handleSubmit = (e) => {
    const { filters } = this.state;
    filters.skip = 0;
    this.setState({ disable: false });
    this.props.dashboardOutbound(
      datetimeHelper.toFormat(
        this.state.filters.where.from,
        "YYYY-MM-DD startDay"
      ),
      datetimeHelper.toFormat(this.state.filters.where.to, "YYYY-MM-DD endDay"),
      this.state.number,
      this.state.groupId
    );
  };

  _export;
  export = () => {
    this._export.save();
  };

  handleDateChangeStart = (from) => {
    const { filters } = this.state;
    filters.where.from = datetimeHelper.toFormat(from, "YYYY-MM-DD");
    this.setState({ from });
  };

  handleDateChangeEnd = (to) => {
    const { filters } = this.state;
    filters.where.to = datetimeHelper.toFormat(to, "YYYY-MM-DD");
    this.setState({ to });
  };

  handleChange = (name) => {
    return (e) => {
      return this.setState({
        [name]: e.target.value,
      });
    };
  };

  onChangeFilters(name, value) {
    this.setState({ [name]: value });
  }

  onChangeFiltersSearch(name, value) {
    const { contacts = [] } = this.props;
    const { filters } = this.state;
    filters.where[name] = value;
    this.setState({ filters: filters });
  }

  render() {
    const { filters } = this.state;
    const { classes, outboundHours, listAgentGroups, listPhoneNumber } =
      this.props;
    const listAgentGroupsResult =
      typeof listAgentGroups === "object"
        ? Object.keys(listAgentGroups).map((key) => listAgentGroups[key])
        : listAgentGroups;
    const listPhoneNumberResult =
      typeof listPhoneNumber === "object"
        ? Object.keys(listPhoneNumber).map((key) => listPhoneNumber[key])
        : listPhoneNumber;
    return (
      <React.Fragment>
        <ValidatorForm
          ref="form"
          onSubmit={this.handleSubmit}
          onError={(errors) => console.log(errors)}
          className={classes.form}>
          <Card className={classes.card}>
            <CardContent>
              <FormControl className={classes.form}>
                <FormGroup className={classes.form}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <Grid container spacing={24}>
                      <Grid item md={4} className="flexGridCareReport">
                        <div
                          className="autocomplete-list-phone-number__container"
                          style={{ marginTop: 18 }}>
                          <label className="autocomplete-list-phone-number__label">
                            Đầu số
                          </label>
                          <SelectAntd
                            showSearch
                            placeholder="Tất cả"
                            optionFilterProp="children"
                            value={this.state.number}
                            className="autocomplete-list-phone-number__select"
                            popupClassName="autocomplete-list-phone-number__dropdown"
                            onChange={this.onChangeFilters.bind(this, "number")}
                            filterOption={(input, option) =>
                              (option?.label ?? "")
                                .toLowerCase()
                                .includes(input.toLowerCase())
                            }
                            options={[
                              { value: null, label: "Tất cả" },
                              ...(listPhoneNumberResult || []).map((d) => ({
                                value: d.id,
                                label: d.id,
                              })),
                            ]}
                          />
                        </div>
                      </Grid>

                      <Grid item md={4} className="flexGridCareReport">
                        <div
                          className="autocomplete-list-phone-number__container"
                          style={{ marginTop: 18 }}>
                          <label className="autocomplete-list-phone-number__label">
                            Group
                          </label>
                          <SelectAntd
                            showSearch
                            placeholder="Tất cả"
                            optionFilterProp="children"
                            value={this.state.groupId}
                            className="autocomplete-list-phone-number__select"
                            popupClassName="autocomplete-list-phone-number__dropdown"
                            onChange={this.onChangeFilters.bind(
                              this,
                              "groupId"
                            )}
                            filterOption={(input, option) =>
                              (option?.label ?? "")
                                .toLowerCase()
                                .includes(input.toLowerCase())
                            }
                            options={[
                              { value: null, label: "Tất cả" },
                              ...(listAgentGroupsResult || []).map((d) => ({
                                value: d.id,
                                label: d.name,
                              })),
                            ]}
                          />
                        </div>
                      </Grid>

                      <Grid item md={4}>
                        <InlineDatePicker
                          margin="normal"
                          label="Từ ngày"
                          variant="outlined"
                          className={classes.input}
                          value={filters.where.from}
                          format="dd-MM-yyyy"
                          onChange={this.handleDateChangeStart}
                          name="from"
                          validators={["required"]}
                          errorMessages={[`Không được để trống`]}
                        />
                      </Grid>
                      <Grid item md={4}>
                        <InlineDatePicker
                          margin="normal"
                          label="Đến ngày"
                          variant="outlined"
                          className={classes.input}
                          value={filters.where.to}
                          maxDate={new Date()}
                          minDate={filters.where.from}
                          format="dd-MM-yyyy"
                          onChange={this.handleDateChangeEnd}
                          name="to"
                          validators={["required"]}
                          errorMessages={[`Không được để trống`]}
                        />
                      </Grid>
                      <Grid item md={4}>
                        <Tooltip title="Tìm kiếm" disableFocusListener>
                          <Fab
                            color="primary"
                            aria-label="Search"
                            style={{ marginLeft: "15px", marginTop: "15px" }}
                            className={classes.fab}
                            // onClick={this.handleSubmit}
                            type="submit">
                            <Search />
                          </Fab>
                        </Tooltip>
                        <Tooltip title="Tải báo cáo" disableFocusListener>
                          <Fab
                            color="primary"
                            aria-label="Search"
                            style={{ marginLeft: "15px", marginTop: "15px" }}
                            className={classes.fab}
                            onClick={this.export}>
                            <Icon className={classes.add}>save_alt</Icon>
                          </Fab>
                        </Tooltip>
                      </Grid>
                    </Grid>
                  </MuiPickersUtilsProvider>
                </FormGroup>
                <ExcelExport
                  data={outboundHours}
                  ref={(exporter) => (this._export = exporter)}
                  fileName="Báo cáo gọi ra.xlsx">
                  <ExcelExportColumn
                    field="date"
                    title="Ngày"
                    locked={true}
                    width={90}
                  />
                  <ExcelExportColumn field="hour" title="Giờ" width={80} />
                  <ExcelExportColumn field="calls" title="Tổng" width={80} />
                  <ExcelExportColumn
                    field="answeredCalls"
                    title="Trả lời"
                    width={80}
                  />
                  <ExcelExportColumn
                    field="noAnsweredCalls"
                    title="Không trả lời"
                    width={80}
                  />
                  <ExcelExportColumn field="busyCalls" title="Bận" width={80} />
                  <ExcelExportColumn
                    field="asr"
                    title="Tỉ lệ trả lời"
                    width={80}
                  />
                </ExcelExport>
              </FormControl>
            </CardContent>
          </Card>
        </ValidatorForm>
        {outboundHours.length !== 0 ? (
          outboundHours[0].calls != 0 ? (
            <Paper
              style={{
                marginTop: 15,
                justifyContent: "center",
                display: "flex",
                backgroundColor: "#fff",
                color: "#000",
              }}>
              <Chart
                width={"100%"}
                height={"400px"}
                chartType="ColumnChart"
                loader={<div>Loading Chart</div>}
                data={outboundHours ? outboundHours.reportOutbound : []}
                options={{
                  // Material design options
                  colors: ["#015290", "#fcb71e", "red", "#ffab91"],
                  chartArea: { width: "50%" },
                  title: `Lưu lượng cuộc gọi theo khung giờ (Outbound)`,
                  hAxis: {
                    title: "Thời gian",
                  },
                  vAxis: {
                    title: "Số lượng cuộc gọi",
                    minValue: 0,
                  },
                  seriesType: "bars",
                  series: {
                    3: {
                      type: "line",
                      tooltip: false,
                    },
                  },
                }}
                // For tests
                rootProps={{ "data-testid": "2" }}
              />
            </Paper>
          ) : null
        ) : null}
        <Paper className={classes.root}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <TableCell>Ngày</TableCell>
                <TableCell>Giờ</TableCell>
                <TableCell>Tổng</TableCell>
                <TableCell>Trả lời</TableCell>
                <TableCell>Không trả lời</TableCell>
                <TableCell>Bận</TableCell>
                <TableCell>Tỉ lệ trả lời</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {outboundHours ? (
                outboundHours.map((row, key) => {
                  // console.log(outboundHours)
                  if (row) {
                    return (
                      <TableRow key={key} style={{ whiteSpace: "nowrap" }}>
                        <TableCell component="th" scope="row">
                          {row.date ? row.date : "Total"}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row.hour}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row.calls ? row.calls : 0}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row.answeredCalls ? row.answeredCalls : 0}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row.noAnsweredCalls ? row.noAnsweredCalls : 0}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row.busyCalls ? row.busyCalls : 0}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          <Toolbar title="Tỉ lệ trả lời">
                            {row.asr ? row.asr : "0%"}
                          </Toolbar>
                        </TableCell>
                      </TableRow>
                    );
                  }
                })
              ) : (
                <React.Fragemt />
              )}
            </TableBody>
          </Table>
        </Paper>
        <Dialog open={this.props.loading} title={<CircularProgress />} />
      </React.Fragment>
    );
  }
}

ReportOutbound.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  outboundHours: state.dashboard.outbound,
  loading: state.dashboard.loading,
  listAgentGroups: state.agent.groupAgent,
  listPhoneNumber: state.phoneNumber.phoneNumbers,
});
const NumberConnect = connect(null, phoneNumberAction)(ReportOutbound);
const Group = connect(null, agentAction)(NumberConnect);
ReportOutbound = connect(mapStateToProps, mapActionsToProps)(Group);
export default withStyles(styles)(ReportOutbound);
